import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#262626",
	fill: "none",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 7.5V16.5",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 12H16.5",
			strokeWidth: 1.5
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20stroke%3D%22%23262626%22%20fill%3D%22none%22%3E%0A%3Cpath%20d%3D%22M12%2023.25C18.2132%2023.25%2023.25%2018.2132%2023.25%2012C23.25%205.7868%2018.2132%200.75%2012%200.75C5.7868%200.75%200.75%205.7868%200.75%2012C0.75%2018.2132%205.7868%2023.25%2012%2023.25Z%22%20stroke-width%3D%221.5%22%20%2F%3E%0A%3Cpath%20d%3D%22M12%207.5V16.5%22%20stroke-width%3D%221.5%22%20%2F%3E%0A%3Cpath%20d%3D%22M7.5%2012H16.5%22%20stroke-width%3D%221.5%22%20%2F%3E%0A%3C%2Fsvg%3E";
